import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'fe-appdir-comp-link';
import styled from 'fe-styled-components';

import { buttonCss } from '../style';

/**
 * Custom prop validation for to/href
 * @param {object} props
 * @param {string} propName
 * @param {string} componentName
 * @return {void}
 */
const linkCheck = (props, propName, componentName) => {
  if (!props.href && !props.to) {
    return new Error(
      `One of props '${propName}' or '${
        propName === 'to' ? 'href' : 'to'
      }' was not specified in '${componentName}'.`,
    );
  } else if (
    typeof props[propName] !== 'undefined' &&
    typeof props[propName] !== 'string'
  ) {
    return new Error(`'${propName}' must be a string in '${componentName}'.`);
  }
};

const PROP_TYPES = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['default', 'cta', 'standard', 'primary', 'ghost']),
  target: PropTypes.oneOf(['_self', '_blank', '_parent', '_top']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  href: (props, propName, componentName) =>
    linkCheck(props, propName, componentName),
  to: (props, propName, componentName) =>
    linkCheck(props, propName, componentName),
  gaTrackId: PropTypes.string,
  gaTrackInfo: PropTypes.string,
  className: PropTypes.string,
};
const DEFAULT_PROPS = {
  type: 'default',
  target: '_self',
  size: 'md',
  href: '',
  to: '',
  gaTrackId: null,
  gaTrackInfo: null,
  className: null,
};

const ButtonAnchor = styled.a`
  ${(props) => buttonCss(props)};
`;

const ButtonLink = styled(Link)`
  ${(props) => buttonCss(props)};
`;

/**
 * App <a> Button
 * @param {object} props
 * @return {reactElement}
 */
const AppButtonLink = ({
  children,
  type,
  href,
  to,
  target,
  size,
  className,
  gaTrackId,
  gaTrackInfo,
}) =>
  to ? (
    <ButtonLink
      type={type}
      to={to}
      target={target}
      size={size}
      className={className}
      data-ga-track-id={gaTrackId}
      data-ga-track-info={gaTrackInfo}
    >
      {children}
    </ButtonLink>
  ) : href ? (
    <ButtonAnchor
      type={type}
      href={href}
      target={target}
      size={size}
      className={className}
      data-ga-track-id={gaTrackId}
      data-ga-track-info={gaTrackInfo}
    >
      {children}
    </ButtonAnchor>
  ) : null;

AppButtonLink.propTypes = PROP_TYPES;
AppButtonLink.defaultProps = DEFAULT_PROPS;

export default AppButtonLink;
